<template lang="pug">
#noticias
    BaseHeader(
        :titulo="$t('mensagens.noticias.titulo')",
        icon='el-icon-plus',
        :btnTexto="$t('mensagens.noticias.cadastroNoticia.cadastro')",
        :exibeBotao='true',
        @btnHeaderClicado='alterarMostrarModalCadastroNoticia'
    )

    .view-container-base-header
        .noticias__barra-pesquisa
            i.el-icon-search
            input.lista-noticias__barra-pesquisa__input(
                v-model='paginacao.filter',
                type='text',
                :placeholder="$t('mensagens.noticias.pesquisaInteligente')",
                autocomplete='off',
                @keyup.enter='onChangeSearchInput'
            )

        .tabela
            el-table(
                height='calc(100% - 57px)',
                :data='noticias',
                v-loading='loading'
            )
                el-table-column(prop='titulo', :label="$t('mensagens.noticias.tabela.titulo')", min-width='400', sortable)
                el-table-column(prop='dataCadastroFormatada', :label="$t('mensagens.noticias.tabela.dataCadastro')", min-width='100')
                el-table-column(
                    prop='ativo',
                    :label="$t('mensagens.noticias.tabela.statusNoticia.label')",
                    min-width='100'
                )
                    .template(slot-scope='scope')
                        div(:class='[scope.row.ativo ? "ativo" : "inativo"]')
                            | {{ scope.row.ativo ? $t('mensagens.noticias.tabela.statusNoticia.ativo') : $t('mensagens.noticias.tabela.statusNoticia.inativo')}}

                el-table-column(min-width='50', align='center', :label="$t('mensagens.noticias.tabela.acoes.label')")
                    .template(slot-scope='scope')
                        el-dropdown.acoes(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical

                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-edit'
                                    @click.native='abrirModalEditarNoticia(scope.row)'
                                )
                                    | {{ $t('mensagens.noticias.tabela.acoes.editar') }}

                                el-dropdown-item(
                                    :icon='scope.row.ativo ? "el-icon-remove-outline" : "el-icon-circle-check"',
                                    @click.native='acaoAlterarStatus(scope.row)'
                                )
                                    | {{ scope.row.ativo ? $t('mensagens.noticias.tabela.acoes.desativar') : $t('mensagens.noticias.tabela.acoes.ativar')  }}
                template(slot='empty')
                    el-empty(:description="$t('mensagens.noticias.emptyTemplate')")

            .py-3.btn-paginacao(style='text-align: center')
                el-pagination(
                    background,
                    :page-size='15',
                    :current-page.sync='paginacao.paginaAtual',
                    layout='prev, pager, next',
                    :total='totalNoticias',
                    @current-change='getNoticias'
                )
    el-dialog.modal-cadastrar-noticia(
        :title="$t('mensagens.noticias.cadastroNoticia.cadastro')",
        :visible.sync='mostrarModalCadastroNoticia',
        width='500px',
        :close-on-click-modal='false'
    )
        el-form(:model='novaNoticia')
            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.noticias.cadastroNoticia.titulo') }}
                    span.erro(v-if='$v.novaNoticia.titulo.$invalid') *
                el-input(v-model='novaNoticia.titulo')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.noticias.cadastroNoticia.descricao') }}
                el-input(v-model='novaNoticia.descricao', type='textarea')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.noticias.cadastroNoticia.link') }}
                    span.erro(v-if='$v.novaNoticia.link.$invalid') *
                el-input(v-model='novaNoticia.link')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.noticias.cadastroNoticia.imagem') }}
                    span.erro(v-if='$v.novaNoticia.imagem.$invalid') *
                el-input(v-model='novaNoticia.imagem')
        
        footer(slot='footer')
            el-button(
                size='mini'
                @click='alterarMostrarModalCadastroNoticia'
            ) {{ $t('mensagens.noticias.cadastroNoticia.cancelar') }}
            el-button(
                :disabled='$v.novaNoticia.$invalid',
                size='mini',
                type='primary'
                @click='cadastrarNoticia'
            ) {{ $t('mensagens.noticias.cadastroNoticia.cadastrar') }}

    el-dialog.modal-editar-noticia(
        :title="$t('mensagens.noticias.editarNoticia.editar')",
        :visible.sync='mostrarModalEditarNoticia',
        width='500px',
        :before-close='fecharModalEditarNoticia',
        :close-on-click-modal='false'
    )
        el-form(:model='editarNoticia')
            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.noticias.cadastroNoticia.titulo') }}
                    span.erro(v-if='$v.editarNoticia.titulo.$invalid') *
                el-input(v-model='editarNoticia.titulo')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.noticias.cadastroNoticia.descricao') }}
                el-input(v-model='editarNoticia.descricao', type='textarea')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.noticias.cadastroNoticia.link') }}
                    span.erro(v-if='$v.editarNoticia.link.$invalid') *
                el-input(v-model='editarNoticia.link')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.noticias.cadastroNoticia.imagem') }}
                    span.erro(v-if='$v.editarNoticia.imagem.$invalid') *
                el-input(v-model='editarNoticia.imagem')

        footer(slot='footer')
            el-button(
                size='mini'
                @click='fecharModalEditarNoticia'
            ) {{ $t('mensagens.noticias.cadastroNoticia.cancelar') }}
            el-button(
                :disabled='$v.editarNoticia.$invalid',
                size='mini',
                type='primary'
                @click='salvarEdicao'
            ) {{ $t('mensagens.noticias.editarNoticia.salvarEdicao') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import NoticiasService from '@/services/NoticiasService';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'Noticias',
    components: {
        BaseHeader
    },

    data() {
        return {
            noticias: [],
            noticia: null,
            totalNoticias: 0,
            loading: false,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 15,
                filter: ''
            },
            mostrarModalCadastroNoticia: false,
            novaNoticia: {
                titulo: '',
                descricao: '',
                link: '',
                imagem: '',
                dataCadastro: '',
                statusNoticia: false
            },
            mostrarModalEditarNoticia: false,
            editarNoticia: {
                titulo: '',
                descricao: '',
                link: '',
                imagem: '',
                dataCadastro: '',
                statusNoticia: false
            },
            ordem: null,
            alterarStatusNoticia: {
                status: false
            },
            mostrarModalAlterarStatus: false
        };
    },

    validations() {
        return {
            novaNoticia: {
                titulo: { required },
                link: {required},
                imagem: {required}
            },
            editarNoticia: {
                titulo: { required },
                link: {required},
                imagem: {required}
            }
        };
    },

    created() {
        this.getNoticias();
    },

    methods: {
        async getNoticias() {
            try {
                this.loading = true;
                const {data} = await NoticiasService.buscarNoticiasPaginadas({
                    page: this.paginacao.paginaAtual - 1,
                    filter: this.paginacao.filter
                });
                this.noticias = data.resultados;
                this.totalNoticias = data.totalResultados;
            } catch (error) {
                this.$notify.error({
                    message: error
                });
            } finally {
                this.loading = false;
            }
        },

        alterarMostrarModalCadastroNoticia() {
            this.limparModalCadastroNoticia();
            this.mostrarModalCadastroNoticia =
                !this.mostrarModalCadastroNoticia;
        },

        limparModalCadastroNoticia() {
            this.novaNoticia = {
                titulo: '',
                descricao: '',
                link: '',
                imagem: '',
                dataCadastro: '',
                statusNoticia: false
            };
        },

        cadastrarNoticia() {
            NoticiasService.cadastrarNoticia({
                titulo: this.novaNoticia.titulo,
                descricao: this.novaNoticia.descricao,
                link: this.novaNoticia.link,
                imagem: this.novaNoticia.imagem
            })
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.noticias.cadastroNoticia.cadastradoSucesso')
                    });
                    this.alterarMostrarModalCadastroNoticia();
                    setTimeout(() => {
                        this.getNoticias();
                    }, 1000);
                })
                .catch(error => {
                    this.$notify.error({
                        message: `${error}`
                    });
                });
        },

        onChangeSearchInput() {
            this.getNoticias();
        },

        async abrirModalEditarNoticia({id}) {
            try {
                const {data} = await NoticiasService.buscarNoticiaPeloId(id);
                this.editarNoticia = data;
                this.mostrarModalEditarNoticia = true;
            } catch (error) {
                this.$notify.error({
                    message: error
                });
            }
        },

        fecharModalEditarNoticia() {
            this.mostrarModalEditarNoticia = false;
        },

        salvarEdicao() {
            NoticiasService.editarNoticia({
                titulo: this.editarNoticia.titulo,
                descricao: this.editarNoticia.descricao,
                link: this.editarNoticia.link,
                imagem: this.editarNoticia.imagem
            },
            this.editarNoticia.id
        )
            .then(() => {
                    this.$notify.success({
                        message: 'Notícia editada com sucesso!'
                    });
                    this.fecharModalEditarNoticia();
                    setTimeout(() => {
                        this.getNoticias();
                    }, 1000);
                })
                .catch(error => {
                    this.$notify.error({
                        message: `Ocorreu um erro ao editar o notícia: ${error}`
                    });
                });
        },

        alterarModalAlterarStatus() {
            this.mostrarModalAlterarStatus = !this.mostrarModalAlterarStatus;
        },

        acaoAlterarStatus({id, ativo}) {
            this.alterarStatusNoticia = {
                status: ativo
            };
            NoticiasService.inativarNoticia(id, ativo)
            .then(() => {
                this.$notify.success({
                    message: this.alterarStatusNoticia.status
                            ? this.$t('mensagens.noticias.tabela.statusNoticia.noticiaInativa')
                            : this.$t('mensagens.noticias.tabela.statusNoticia.noticiaAtiva')
                });
                this.alterarModalAlterarStatus();
                setTimeout(() => {
                    this.getNoticias();
                }, 1000);
            })
            .catch(error => {
                    this.$notify.error({
                        message: `Ocorreu um erro ao ${
                            this.alterarStatusNoticia.status
                                ? 'inativar'
                                : 'ativar'
                        } a noticía: ${error}`
                    });
            });
        }
    }
};
</script>

<style lang="scss">
#noticias {
    .noticias__barra-pesquisa {
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        background-color: var(--white);
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        i.el-icon-search {
            color: var(--primary);
            font-size: 25px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-noticias__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .pagination {
        background-color: var(--white);
        border-radius: 0 0 2px 2px;
        justify-content: center;
    }

    .tabela {
        border-radius: 5px;
        overflow: hidden;
        background-color: var(--white);
        height: calc(100vh - 258px);
        width: 100%;
        padding-top: 0 !important;
        padding-bottom: 0 !important;

        .acoes:hover {
            cursor: pointer;
        }
    }

    .ativo,
    .inativo {
        border-radius: 20px;
        text-align: center;
        max-width: 120px;
        color: var(--black);
    }

    .ativo {
        background-color: #d1ead2;
        border: 1px solid #bae0bc;
    }

    .inativo {
        background-color: #ffaeae;
        border: 1px solid var(--danger);
    }

    .modal-cadastrar-noticia,
    .modal-editar-noticia {
        footer {
            display: flex;
            justify-content: space-between;

            .el-button {
                width: 80px;
            }
        }

        .label {
            display: flex;
            align-items: center;
            gap: 4px
        }

        .label-line {
            display: block;
        }

        .erroInput {
            border-radius: 4px;
            border: 1px solid red;
        }

        .erro {
            color: red;
            font-size: 10px;
            display: block;
            line-height: 1.5;
        }

        .el-form-item__label {
            margin-bottom: -10px;
        }
    }

    .el-select {
        width: 460px;
    }
}
</style>
